import React, { useState } from "react";
//styling & animation
import styled from "styled-components";
import { motion } from "framer-motion";
import { fadeIn } from "../animation";
//logo
import logo from "../img/logo.svg";
//redux & routes
import { fetchSearch, clearSearch } from "../actions/gamesAction";
import { useDispatch } from "react-redux";

const Nav = () => {
  const dispatch = useDispatch();
  //local state
  const [textInput = "", setTextinput] = useState();

  const textHandler = (e) => {
    setTextinput(e.target.value);
  };

  const clearSearched = () => {
    dispatch(clearSearch());
    setTextinput("");
  };

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(fetchSearch(textInput));
    setTextinput("");
  };

  return (
    <StyledNav variants={fadeIn} initial='hidden' animate='show' exit='exit'>
      <Logo onClick={clearSearched}>
        <img src={logo} alt='logo' />
        <h1>ignite</h1>
      </Logo>
      <form className='search' onSubmit={submitHandler}>
        <input type='text' onChange={textHandler} value={textInput} />
        <button>search</button>
      </form>
    </StyledNav>
  );
};

const StyledNav = styled(motion.nav)`
  padding: 3rem 5rem;
  text-align: center;
  h1 {
    font-size: 4rem;
    margin-bottom: 1rem;
  }
  input {
    width: 30%;
    font-size: 1.2rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
    font-family: "Orbitron", sans-serif;
    &:focus {
      outline: none;
    }
  }
  @media (max-width: 1600px) {
    input {
      width: 50%;
    }
  }
  @media (max-width: 1000px) {
    input {
      width: 70%;
    }
  }
  @media (max-width: 600px) {
    padding: 2rem 0;
    input {
      width: 90%;
      margin-bottom: 1rem;
    }
  }
  button {
    font-size: 1.2rem;
    font-family: "Orbitron", sans-serif;
    cursor: pointer;
    border: none;
    padding: 0.5rem 1rem;
    margin-left: 1rem;
    border-radius: 1rem;
    background: #ff7676;
    color: white;
  }
`;

const Logo = styled(motion.div)`
  display: flex;
  justify-content: center;
  cursor: pointer;
  img {
    height: 4rem;
    width: 4rem;
    margin-right: 1rem;
  }
`;

export default Nav;
